import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useReactiveVar } from '@apollo/client'
import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { RequestForm } from 'shared-components'
import { Analytics } from 'shared-components'
import { Subheader } from 'shared-components'

import {
  alertType,
  appointmentsAvailable,
  locationData,
  message,
  patientData,
  store,
} from '../../cache'

export const RequestAppointment = () => {
  const navigate = useNavigate()
  const { locationId, partnerId } = useReactiveVar(store)
  const availability = useReactiveVar(appointmentsAvailable)
  const { t } = useTranslation()

  useEffect(() => {
    Analytics.requestStarted({
      locationId,
      partnerId,
    })
  }, [locationId, partnerId])

  const navigateToDatetimeSelect = () => {
    Analytics.requestCancelled({
      locationId,
      partnerId,
    })
    navigate('/')
  }
  return (
    <Grid aria-label="request-appointment-container">
      <Grid
        item
        container
        aria-label="request-appointment-body"
        flexDirection="column"
        gap={5}
        pt={4}
        pb={5}
      >
        <Grid
          item
          container
          aria-label="back-button"
          flexDirection="column"
          alignContent="center"
        >
          {availability ? (
            <Button
              color="primary"
              data-testid="back-button"
              onClick={navigateToDatetimeSelect}
              startIcon={<KeyboardBackspaceRoundedIcon />}
              variant="outlined"
            >
              {t('Check available appointments')}
            </Button>
          ) : null}
        </Grid>
        <Grid item container aria-label="patient-form-section" gap={1}>
          <Subheader text={t('Patient Information')} />
          <Typography
            align="center"
            variant="subtitle2"
            sx={{ fontWeight: 400 }}
            color={'var(--intelibly-branding-neutral-900)'}
          >
            {t(
              'This office is currently accepting appointment requests. An office representative will contact you to schedule a time and date.'
            )}
          </Typography>
          <RequestForm
            alertType={alertType}
            locationData={locationData}
            message={message}
            patientData={patientData}
            store={store}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}
